



















import { inject } from "inversify-props";
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { PatientModel } from "@/models/patient";
import { auth, patient as store } from "@/store/modules";
import { IPatientService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
class PatientSelector extends Vue {
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  @Prop() patientIds?: string[];
  private disabled = auth.isPatient;

  private async refresh() {
    this.isLoading = true;
    try {
      let size = 100,
        page = 1,
        total = 0;
      do {
        const [items, {}] = await this.patientService.getMany(page, size);
        this.items = [...items];
        this.items = items.sort((a, b) => (a.name > b.name ? 1 : -1));
      } while (page * size < total);
    } finally {
      this.isLoading = false;
    }
  }

  async mounted() {
    await this.refresh();
    if (this.patientIds) {
      this.value = this.patientIds;
    }
  }

  private isLoading = true;
  private items: Array<PatientModel> = [];
  private value: string[] | null = null;

  @Emit("change")
  onChange(value: string[] | null) {
    return value;
  }
}

export default PatientSelector;
